import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { setApiBaseUrl } from '@recipe/shared';

const workerUrl = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? 'https://recipe-api.jqpig.com' : '');
if (workerUrl) {
  setApiBaseUrl(workerUrl);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
